
import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { FaArrowRight } from 'react-icons/fa';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo_White.png';
import blueBanner from '../../ImageAssets/blueBanner.png';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import { setRegisterDetails, setLoginPage, setIsUserLoggedInTrue, setCurrentPage, setUserDetails, setForgetPasswordDetails, setUserRegisterDetails } from '../../General/Actions';
import Swal from 'sweetalert2';
import PopupModal from '../../Utils/modalComponent.js';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Constants from '../../Utils/constants.json';
import GeneralUtils from '../../Utils/generalUtils.js';
import SliderModal from '../../Utils/sliderModal.js';

class LoginPageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            username: "",
            password: "",
            state: "",
            contentForPopup: "",
            headingForPopup: "",
            isSubmitButtonVisibleForPopup: false,
            isCancelButtonVisibleForPopup: true,
            isSwalVisible: false,
            phoneNumber: "",
            isLoadTandCSliderModalVisible: false
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.setState({
            phoneNumber: this.getUrlParameter("mobileNumber")
        }, () => {
            if (this.state.phoneNumber !== "" && this.state.phoneNumber !== null && this.state.phoneNumber !== undefined) {
                if (localStorage.getItem("isSignInOptionClickedForMobile")) {
                    localStorage.removeItem("isSignInOptionClickedForMobile");
                    this.setState({ isLoading: false })
                } else {
                    this.redirectToOtp();
                }
            } else {
                this.setState({ isLoading: false })
            }
        })

        Network.executeAxios("checkPaymentDetailsWol", "POST", "", (response) => {
            this.setState({ isLoading: false });
            console.log("checkPaymentDetails >> ", response);
            if (response && response.orderId && response.reason && response.status) {
                var reason = response.reason;
                if (reason == "bill_payment_wol") {
                    reason = "bill";
                } else if (reason == "recharge_wol") {
                    reason = "recharge";
                }
                if (response.status === "SUCCESS") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Successful",
                            html: "<div>Your payment for " + reason + " has been successful</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                            type: '',
                            timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                } else if (response.status === "TO_REFUND") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Failed to place the order",
                            html: "<div>Amount debited will be refunded within 5 working days</div>",
                            type: '',
                            timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                } else {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Failed",
                            html: "<div>Your payment for " + reason + " has been Failed</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                            type: '',
                            timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                }
            }
        });

        // Network.executeAxios("getAllStates", "POST", "", (response) => {
        //     this.setState({ isLoading: false });
        //     this.populateAllStates(response);
        // });
    }

    redirectToOtp() {
        var contactNumFromUrl = this.state.phoneNumber.slice(-(Constants.contactNumberLength));
        var formattedContactNum = GeneralUtils.formatPhoneNumberToUsFormatNew(contactNumFromUrl)
        var dataToSend = {
            phoneNumber: formattedContactNum
        }
        this.setState({ isLoading: true })
        Network.executeAxios("signInWithPhoneNumber", "POST", dataToSend, (signInWithPhoneNumberResponse) => {
            if (signInWithPhoneNumberResponse.STATUS === "SUCCESS") {
                var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
                var dataToSend = {
                    otp: generatedOtp,
                    contactNum: formattedContactNum
                }
                this.state.customerId = signInWithPhoneNumberResponse.PROFILE_ID;
                Network.executeAxios("otpAuth", "POST", dataToSend, (response) => {
                    if (response.result_code && response.result_code === "0") {
                        this.props.setForgetPasswordDetails("profileContactNumber", formattedContactNum);
                        this.props.setUserRegisterDetails("generatedOtp", generatedOtp);
                        var isMobile = false;
                        if (window.location.href.indexOf("mobile") > -1) {
                            isMobile = true;
                        }
                        Network.executeAxios("loginWithOtp", "POST", { "profileId": this.state.customerId, "isMobile": isMobile }, (response) => {
                            var retreivedUsername = signInWithPhoneNumberResponse.USERNAME;
                            this.props.setForgetPasswordDetails("retreivedUsername", retreivedUsername);
                            this.props.setLoginPage("pageName", "signInWithOTP");
                        })
                    } else {
                        this.setState({ isLoading: false })
                        Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
                    }
                })

            } else if (signInWithPhoneNumberResponse.STATUS === "USER_NOT_EXIST") {
                this.setState({ isLoading: false })
                Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
            } else if (signInWithPhoneNumberResponse.STATUS === "FAILED") {
                this.setState({ isLoading: false })
                Swal.fire(this.props.locales.forgetUserNameOperationFailedSwal, "", "");
            }
        });
    }

    getUrlParameter(param) {
        var found;
        window.location.pathname.substr(1).split("&").forEach(function (item) {
            if (param == item.split("=")[0]) {
                found = item.split("=")[1];
            }
        });
        return found;
    };

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }

    registerButtonClicked = () => {
        this.props.setLoginPage("pageName", "register")
    }

    forgetPasswordLinkClicked = () => {
        this.props.setLoginPage("pageName", "forgetPassword")
    }

    signInWithOTPLinkClicked = (type) => {
        if (type === "signin") {
            this.props.setLoginPage("pageName", "customerIdForOTP")
        } else if (type === "signup") {
            this.props.setLoginPage("pageName", "register")
        }

    }

    forgetUsernameLinkClicked = () => {
        this.props.setLoginPage("pageName", "forgetUsername")
    }

    tAndCModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ isLoadTandCSliderModalVisible: false })
        } else if(dataObject.type === "submit"){
            document.body.classList.remove('modal-open');
            this.setState({isLoading: true})
            Network.executeAxios("tAndCAgreed", "POST", "" , (TandCResponse) => {
                this.setState({isLoading: false})
                if(TandCResponse && TandCResponse.STATUS && TandCResponse.STATUS === "SUCCESS"){
                    this.setState({isLoading: true})
                    Network.executeAxios("getUniqueToken", "POST", "", (response) => {
                        localStorage.setItem("uniqueToken", response.UniqueToken)
                        localStorage.setItem("isUserLoggedIn", "true");
                        if (window.location.href.indexOf("mobile") > -1) {
                            localStorage.setItem("isMobile", "true");
                        }
                        localStorage.setItem("activeUsername", this.state.username);
                        this.props.setIsUserLoggedInTrue();
                        this.setState({ isLoadTandCSliderModalVisible: false, isLoading: false })
                    })
                } else {
                    Swal.fire(this.props.locales.internalErrorTitleInSwal)
                }
            })
        }
    }

    loginButtonClicked = () => {
        if(this.props.locales.isMaintenanceModeOn === "1"){
            Swal.fire(this.props.locales.applnUnderMaintenanceMsg)
        } else {
            this.setState({ isLoading: true });
            var userName = this.state.username;
            var isMobile = false;
            // if (this.props.forgetPasswordDetails.retreivedUsername != "") {
            //     userName = this.props.forgetPasswordDetails.retreivedUsername
            // }
            if (window.location.href.indexOf("mobile") > -1) {
                isMobile = true;
            }
            Network.executeAxios("loginCheck", "POST", { "username": userName, "password": this.state.password, "isMobile": isMobile }, (response) => {
                this.setState({ isLoading: false });
                localStorage.removeItem("isMobile");
                if (response.STATUS === "SUCCESS") {
                    if(response.ACCOUNT_ID){
                        Network.executeAxios("getUniqueToken", "POST", "", (response) => {
                            localStorage.setItem("uniqueToken", response.UniqueToken)
                            localStorage.setItem("isUserLoggedIn", "true");
                            if (window.location.href.indexOf("mobile") > -1) {
                                localStorage.setItem("isMobile", "true");
                            }
                            localStorage.setItem("activeUsername", userName);
                            this.props.setIsUserLoggedInTrue();
                        })
                    } else {
                        Swal.fire(this.props.locales.forgetPswPageFailedInvalidUserSwal, "", "");
                    }

                } else if (response.STATUS === "BLOCKED") {
                    Swal.fire(this.props.locales.forgetPswPageBlockedUserSwal, "", "");
                } else if (response.STATUS === "TandC") {
                    // 1. load Tand c html 
                    // 2. Accept -> update table TANDC to `F`
                    // 3. login & goto dashboard page
                    document.body.classList.add('modal-open');
                    this.setState({isLoadTandCSliderModalVisible: true})
                } else if (response.STATUS === "FAILED") {
                    Swal.fire(this.props.locales.forgetPswPageFailedInvalidUserSwal, "", "");
                } else if (response.STATUS === "USER_NOT_EXIST") {
                    Swal.fire(this.props.locales.loginPageBlockedUserSwal, "", "");
                } else if (response.STATUS === "DELETED_USER") {
                    Swal.fire(this.props.locales.loginPageDeletedUserSwal, "", "");
                } else if (response.STATUS === "FORCE_PASS") {
                    this.props.setUserDetails("username", userName);
                    this.props.setLoginPage("pageName", "resetPassword")
                } else if(response.STATUS === "INVALID_DATA"){
                    Swal.fire(this.props.locales.loginPageInvalidDataSwal, "", "");
                } 
                else {
                    Swal.fire(this.props.locales.loginPageInvalidSwal, "", "");
                    //this.showSwal(this.props.locales.loginPageInvalidSwal,"","","OK")
                }
            });
        }
    }


    showSwal(heading, content, isSubmitVisile, cancelButtonText) {
        this.setState({
            headingForPopup: heading,
            contentForPopup: content,
            isSwalVisible: true,
            cancelButtonText: cancelButtonText
        })
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        )
    }

    componentContent() {
        const loginPageOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between"};
        return (
            <div style={loginPageOuterMainContainerStyle} >
                <div className="" style={{ flex: 1,display:"flex" }}>
                    {/* <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="d-none d-sm-block registerPartContainerDiv" style={{ display: "flex", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            {this.registerPartComponent()}
                        </div>
                    </div> */}
                    <div className="col-md-12 p-0" style={{flex: 1,display:"flex"}}>
                        <div style={{ display: "flex", flex: 1 }}>
                            {this.loginPartComponent()}
                        </div>
                    </div>
                    {/* <div className="col-md-12 footer-part row m-0 text-center justify-content-center align-content-center">
                        Copyright 2018 APUA INET
                    </div> */}
                </div>

                <PopupModal
                    isVisible={this.state.isSwalVisible}
                    uniqueModalReferenceId=""
                    content={this.state.contentForPopup}
                    mainHeading={this.state.headingForPopup}
                    isCancelButtonVisible={this.state.isCancelButtonVisibleForPopup}
                    isSubmitButtonVisible={this.state.isSubmitButtonVisibleForPopup}
                    cancelButtonText={this.state.cancelButtonText}
                    callback={this.PopupModalCallBack}
                />
                  <SliderModal
                    isVisible={this.state.isLoadTandCSliderModalVisible}
                    uniqueModalReferenceId="TermsAndConditions"
                    mainHeading={this.props.locales.TandCMainHeading}
                    isResetButtonVisible={false}
                    leftPartFlexValue={1}
                    rightPartFlexValue={3}
                    submitButtonText="Accept"
                    callback={this.tAndCModalHandler}
                >
                    <div className="col-md-12 px-2" style={{ height: '100%' }} >
                        <iframe title="" src="./TermsAndConditions.html" style={{ width: '100%', height: '100%', border: 'none' }} frameBorder="0"> </iframe>
                    </div>
                </SliderModal>

            </div>
        )

    }

    registerPartComponent() {
        return (
            <div className="d-flex flex-column" style={{ height: '100%' }}>
                <div className="col-md-12 row pt-5 m-0" style={{ flex: 1 }}>
                    <div className="col-md-1"></div>
                    <div className="col-md-6 pl-5 ml-3"><img alt="" src={ApuaWhiteTextLogo} /></div>
                    <div className="col-md-5"></div>
                </div>
                <div className="col-md-12 row p-0 m-0 " style={{ flex: 4, alignItems: 'center' }}>
                    <div className="col-md-1"></div>
                    <div className="loginPageLeftPart col-md-9">
                        <div className="col-md-12  pl-5" style={{ marginTop: '-65px' }}>
                            <div className="mb-4 col-md-12" style={{ fontSize: 40, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPageYoutAccountDiv}</div>
                            <div className="mb-1 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPagePayDiv}</div>
                            <div className="mb-1 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPageManageDiv}</div>
                            <div className="mb-2 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.LoginPageGetNotificationDiv}</div>
                            <div className="col-md-12 " style={{ marginTop: 50 }}>
                            {this.props.locales.enableSignUpflow === "true" ?
                                <Button className="loginPageRegisterButton" style={{ color: '#ffffff', fontSize: 18 }} onClick={() => { this.registerButtonClicked() }}>
                                    {this.props.locales.LoginPageDoNtHavAnAccountBtn} <span style={{ fontSize: 18, fontWeight: 'bold', color: '#ffffff' }}> {this.props.locales.LoginPageSignUpBtnSpan}</span>
                                </Button>
                            : null }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className="col-md-12 p-0 m-0" style={{display:"flex",flex:1}}>

                <div className="col-md-12 p-0 m-0" style={{display:"flex",flex:1,flexDirection:"column"}}>
                <div className='p-5' style={{  backgroundImage: `url(${blueBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%"}}>
                    <div className='pb-5' style={{}}>
                        <img alt="" src={ApuaWhiteTextLogo} />
                    </div>
                </div>
                    
                        
                <div className="loginPageLeftPart col-md-3 row m-0 p-0 mx-auto " style={{ height: 'inherit', alignItems: 'center'}}>
                    {/* <div className="row d-none d-sm-block col-md-12 mx-auto mb-4" style={{ visibility: 'hidden' }}>
                        <div className="col-md-12" style={{ lineHeight: 0, textAlign: 'center' }}>
                            <div className="forgetLabel">{this.props.locales.wouldYouLikeToTextInLoginPage}</div>
                            <hr></hr>
                        </div>
                    </div> */}
                    {/* {this.props.locales.isMaintenanceModeOn === "1"
                    ?
                    <div className='col-md-12 text-right font-weight-bold'> * {this.props.locales.applnUnderMaintenanceMsg}</div>
                    : null
                    } */}
                    <div className="col-md-12" style={{}}>
                        {/* <div className="row" style={{ visibility: 'hidden', height: 45 }}></div> */}
                        {/* <div className="col-md-12" style={{ fontSize: 30, color: '#404042' }}>{this.props.locales.LoginPageWelcomDiv}</div>
                        <div className="col-md-12 " style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.LoginPageSignInAndManageTxt}</div> */}
                        <div className="col-md-12 ">
                            {/* <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>User name</label> */}
                            {/* <label className={this.props.forgetPasswordDetails.retreivedUsername != "" ? " m-0" : "d-none animated slideInUp m-0"} style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.LoginPageUserNameLabel}</label> */}
                            <Input type="text" autoComplete="new-password" className="loginCredItem py-4"
                                placeholder={this.props.locales.loginPageEmailPlcText}
                                value={this.state.username}
                                style={{ color: '#404042', fontWeight: 500 }}
                                // onKeyUp={(event) => this.displayLabel(event, this.state.username, this.props.locales.loginPageEmailPlcText)}
                                onChange={(event) => this.inputValueChange("username", event.target.value)}
                            />
                        </div>
                        <div className="col-md-12 " style={{ marginTop: 40 }}>
                            {/* <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.LoginPagePasswordLabel}</label> */}
                            <Input type="password" autoComplete="new-password" className="loginCredItem py-4"
                                placeholder={this.props.locales.loginPagePaswordPlcText}
                                value={this.state.password}
                                style={{ color: '#404042', fontWeight: 500 }}
                                // onKeyUp={(event) => this.displayLabel(event, this.state.password, this.props.locales.loginPagePaswordPlcText)}
                                onChange={(event) => this.inputValueChange("password", event.target.value)}
                            />
                        </div>
                        <div className="justify-content-center pt-3 col-md-12 pb-4 ">
                            <div className="forgetLabel col-md-12 text-center pr-0" onClick={() => { this.forgetPasswordLinkClicked() }}>{this.props.locales.LoginPageForgetPasswordFunc}</div>
                            {this.props.locales.enableForgotUsernameFlow === "true" &&
                            <div className="forgetLabel col-md-12 text-center pl-0" onClick={() => { this.forgetUsernameLinkClicked() }}>
                                {this.props.locales.LoginPageForgetUserNameFunc}
                            </div>
                            // : 
                            // <div className="forgetLabel col-md-6 text-left pl-0>"></div>
                            }
                            <div  className="forgetLabel col-md-12 text-center" onClick={() => { this.signInWithOTPLinkClicked('signup') }}>Register for a new account</div>

                        </div>
                        {/* <div className="d-sm-block d-block pb-5 mb-2">
                            <div className="d-flex col-md-12 justify-content-center">
                                <div style={{ color: '#0285CA', fontSize: 16, cursor: 'pointer' }} onClick={() => { this.signInWithOTPLinkClicked('signup') }}>{this.props.locales.dontHaveAnAccountTextInLoginPage}<span style={{ fontWeight: 'bold' }}>Signup</span></div>
                            </div>
                        </div> */}
                        <div className="col-md-8 m-auto " style={{ marginTop: 40 }}>
                            <div className="loginPageLoginButton p-3" onClick={() => { this.loginButtonClicked() }}>
                                {this.state.isLoading ? this.props.locales.loginPageValidatingText : this.props.locales.loginPageLoginButtonText}&nbsp;
                            </div>
                        </div>
                        
                        {/* <div className="d-flex pt-3 col-md-12 justify-content-center pb-5 mb-2">
                            <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.signInWithOTPLinkClicked('signin') }}>{this.props.locales.singInUsingOtpTextInLoginpage}</div>
                        </div> */}
                        
                        <div style={{ height: 80 }}></div>

                    </div>
                </div>
                </div>

            </div>
        )
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        forgetPasswordDetails: state.forgetPasswordDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        },
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setIsUserLoggedInTrue: function () {
            dispatch(setIsUserLoggedInTrue());
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload))
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload));
        }
    }
}

const LoginPageComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginPageComponent)


export default LoginPageComponentContainer;